module.exports = "<div class=site>\n    <div class=site-portrait></div>\n    <site-content></site-content>\n    <site-sidebar></site-sidebar>\n</div>";